// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchInput_input__3osZK","icon":"SearchInput_icon__ohR3e","link":"SearchInput_link__2hPLG","linkIcon":"SearchInput_linkIcon__xZAzz"};